import { render, staticRenderFns } from "./ItemListItem.vue?vue&type=template&id=5b2ded96&scoped=true"
import script from "./ItemListItem.vue?vue&type=script&lang=js"
export * from "./ItemListItem.vue?vue&type=script&lang=js"
import style0 from "./ItemListItem.vue?vue&type=style&index=0&id=5b2ded96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ded96",
  null
  
)

export default component.exports